import {Observable, switchMap, of, concatMap, tap, from, shareReplay, defer} from "rxjs";
import {CacheItem} from "./CacheItem";
import {HttpClient} from "@angular/common/http";
import {IFont} from "../../types/IFont";
import {catchError, delay, last, map} from "rxjs/operators";
import {CacheBlob} from "./CacheBlob";
import {Log, LogTag} from "../Log";
import {CachingService} from "./caching.service";


export class CacheFont extends CacheBlob {
    fontKey;
    applied;

    constructor(cachingService: CachingService, httpClient: HttpClient, url: string, folder: string, fontKey: string) {
        super(cachingService, httpClient, url, folder, null);
        this.fontKey = fontKey;
    }

    static getFontKey(font: IFont): string {
        let fontKey = font.fontFamily;
        if (font.fontWeight != "Normal" && font.fontWeight != "none" && font.fontWeight != "normal" && font.fontWeight != "bold") {
            fontKey += font.fontWeight;
        }
        if (font.fontStyle != "Normal" && font.fontStyle != "normal" && font.fontStyle != "italic") {
            fontKey += font.fontStyle;
        }
        fontKey = fontKey.replace(/[\s\[\]\-!•™&:.,()`'?]/g, '');
        return fontKey;
    }

    request(expiration: number): Observable<any> {
        this.cachingService.updateLastUsed(this.folder, this.url)
        return from(caches.match(this.url)).pipe(
            switchMap(cachedResponse => {
                if (cachedResponse) {
                    return of('font');
                } else {
                    return this.putInCached(this.url, this.folder);
                }
            }),
            switchMap(url => this.applyFont())
        )
    }

    applyFont(): Observable<any> {
        if (!this.applied) {
            this.applied = defer(() => {
                const style = document.createElement('style');
                style.textContent = `
                    @font-face {
                      font-family: '${this.fontKey}';
                      src: url('${this.url}') format('truetype');
                    }
                  `;
                document.head.appendChild(style);

                const fontSpec = `16px ${this.fontKey}`;
                return from(document.fonts.load(fontSpec)).pipe(
                    switchMap(() => from(document.fonts.ready))
                );
            }).pipe(
                shareReplay(1) // cache the result for future calls
            );
        }

        return this.applied;
    }

}
